import ExpandMore from "@mui/icons-material/ExpandMore";
import { Button, Menu, MenuList } from "@mui/material";
import { Dispatch, SetStateAction, createContext, useContext, useState } from "react";

import { CohortMemberRow } from "../Members";
import { ChangeStatusMenuItem, ChangeStatusDialog } from "./ChangeStatus";

const buttonId = "bulk-actions-button";
const menuId = "bulk-actions-menu";

type BulkActionMenuProps = {
  selectedRows: CohortMemberRow[];
};

type DialogState = "changeStatus" | null;

const bulkActionContext = createContext<{
  selectedRows: CohortMemberRow[];
  dialogState: DialogState;
  setDialogState: Dispatch<SetStateAction<DialogState>>;
  onClose: () => void;
}>({
  selectedRows: [],
  dialogState: null,
  setDialogState: () => {},
  onClose: () => {},
});

export function useBulkActionContext() {
  return useContext(bulkActionContext);
}

const BulkActionsMenu = ({ selectedRows }: BulkActionMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [dialogState, setDialogState] = useState<DialogState>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const onClose = () => {
    setAnchorEl(null);
    setDialogState(null);
  };

  return (
    <bulkActionContext.Provider value={{ selectedRows, onClose, dialogState, setDialogState }}>
      <Button
        id={buttonId}
        size="medium"
        aria-controls={open ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        disabled={!selectedRows.length}
        variant="contained"
        onClick={handleClick}
        endIcon={<ExpandMore />}
        sx={{ whiteSpace: "nowrap" }}
      >
        Bulk Actions
      </Button>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        MenuListProps={{ "aria-labelledby": buttonId }}
      >
        <MenuList>
          <ChangeStatusMenuItem />
        </MenuList>
      </Menu>
      <ChangeStatusDialog />
    </bulkActionContext.Provider>
  );
};

export { BulkActionsMenu };
